<template>
    <div class="mail-shelve">
        <v-row class="mail-shelve__row">
            <v-col
                cols="12"
                md="6"
            >
                <ClInput
                    ref="scan"
                    v-model="scan"
                    type="text"
                    autofocus
                    placeholder="Scan a Shelf or Product"
                    prependInnerIcon="mdi-mailbox-open"
                    @keyup.enter="processScan"
                />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="shelf"
            >
                <ShelfHeading
                    :locator="locator"
                    :loading="shelfInFlight"
                />
                <ClButton
                    type="secondary"
                    class="shelf__change"
                    @click="clearAll()"
                >
                    Clear All
                </ClButton>
                <ClButton
                    v-if="false"
                    type="secondary"
                    class="shelf__change"
                    :elevation="0"
                    @click="clearShelf(); focusScan()"
                >
                    Change
                </ClButton>
            </v-col>
        </v-row>
        <v-row class="mail-shelve__row">
            <v-col
                cols="12"
                class="table-heading"
            >
                <ScanTableHeading
                    :locator="locator"
                    :scannedAmount="scannedItems.length"
                    fixedHeader
                />
            </v-col>
            <v-col cols="12">
                <ClTableSimple
                    :items="scannedItems"
                    :headers="unshelvedHeaders"
                    height="45vh"
                    class="shelving-table"
                    fixedHeader
                >
                    <template #[`item.status`]="{ item }">
                        <ItemStatus :item="item"/>
                    </template>
                    <template #[`item.remove`]="{ item }">
                        <ClButton
                            v-if="item.status !== 'complete' && item.status !== 'loading'"
                            icon
                            aria-label="Remove Item"
                            @click="removeItemAndFocusScan( item )"
                        >
                            <v-icon>mdi-delete-outline</v-icon>
                        </ClButton>
                    </template>
                </ClTableSimple>
            </v-col>
        </v-row>
        <v-row class="mail-shelve__row">
            <v-col
                cols="12"
                class="table-heading"
            >
                <span>Shelved Items History</span>
            </v-col>
            <v-col cols="12">
                <ClTableSimple
                    :items="shelvedItems"
                    :headers="shelvedHeaders"
                    :itemsPerPage="50"
                    height="45vh"
                    class="shelving-table"
                    itemKey="subId"
                    fixedHeader
                    showFooter />
            </v-col>
        </v-row>
    </div>
</template>
<script>
// Vuex
import { mapActions, mapState, mapMutations } from 'vuex';

// Components
import ItemStatus from '@/views/shared/ItemStatus';
import ShelfHeading from '@/views/shared/ShelfHeading';
import ScanTableHeading from '@/views/shared/ScanTableHeading';

export default {
    name: 'MailShelve',
    components: {
        ItemStatus,
        ShelfHeading,
        ScanTableHeading,
    },
    data() {
        return {
            unshelvedHeaders: [
                {
                    text: 'Item ID',
                    value: 'serial',
                    width: '25%',
                },
                {
                    text: 'Recipient',
                    value: 'customer',
                    width: '25%',
                },
                {
                    text: 'Source',
                    value: 'source',
                },
                {
                    text: 'Status',
                    value: 'status',
                    width: 0,
                },
                {
                    text: '',
                    value: 'remove',
                    width: 0,
                },
            ],
            shelvedHeaders: [
                {
                    text: 'Item ID',
                    value: 'serial',
                },
                {
                    text: 'Recipient',
                    value: 'customer',
                },
                {
                    text: 'Source',
                    value: 'source',
                },
                {
                    text: 'Destination',
                    value: 'destination',
                },
            ],
        };
    },
    computed: {
        ...mapState( {
            scanString: ( state ) => state.Mail.Shelve.scanString,
            scannedItems: ( state ) => state.Mail.Shelve.scannedItems,
            shelvedItems: ( state ) => state.Mail.Shelve.shelvedItems,
            shelfInFlight: ( state ) => state.Mail.Shelve.shelfInFlight,
            locator: ( state ) => state.Mail.Shelve.locator,
        } ),
        scan: {
            get() {
                return this.scanString;
            },
            set( scanString ) {
                this.setScanString( { scanString } );
            },
        },
    },
    beforeDestroy() {
        this.$store.dispatch( 'Mail/Shelve/reset' );
    },
    methods: {
        ...mapActions( {
            processScan: 'Mail/Shelve/processScan',
        } ),
        ...mapMutations( {
            clearShelf: 'Mail/Shelve/RESET_LOCATOR',
            clearTable: 'Mail/Shelve/RESET_SCANNED_ITEMS',
            removeScannedItem: 'Mail/Shelve/REMOVE_SCANNED_ITEM',
            setScanString: 'Mail/Shelve/SET_SCAN_STRING',
        } ),
        focusScan() {
            this.$nextTick( () => {
                this.$refs.scan.$el.querySelector( 'input' ).focus();
            } );
        },
        clearAll() {
            this.clearTable();
            this.clearShelf();
            this.focusScan();
        },
        removeItemAndFocusScan( item ) {
            this.removeScannedItem( item );
            this.focusScan();
        },
    },
};
</script>
<style lang="scss" scoped>
    .mail-shelve {
        margin-top: 2rem;
        .shelf {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &__change {
                margin-left: 1rem;
            }
            @include mixins-above(tablet) {
                justify-content: flex-end;
            }
        }
        .shelving-table {
            border: 1px solid rgba( 0, 0, 0, .38 );
            overflow-y: auto;
            &:hover {
                border: 1px solid rgba( 0, 0, 0, .87 );
            }
        }
        &__row {
            .table-heading {
                padding-bottom: 0;
                font-size: 1.25rem;
            }
        }
    }
</style>
